import { Flex, Text, useColorModeValue, useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';

import Configurator from 'layouts/admin/navbar/Configurator';

interface FooterProps {
  theme?: any;
  setTheme?: any;
}

export default function Footer({ theme, setTheme }: FooterProps) {
  const textColor = useColorModeValue('gray.400', 'white');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const currentYear = new Date().getFullYear();

  // Open hidden sidebar on Ctrl + 1 click
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === '1') {
        event.preventDefault();

        if (isOpen) {
          onClose();
          return;
        }

        onOpen();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onOpen, isOpen]);

  return (
    <>
      <Flex
        zIndex="3"
        flexDirection={{
          base: 'column',
          xl: 'row',
        }}
        alignItems={{
          base: 'center',
          xl: 'start',
        }}
        justifyContent="space-between"
        px={{ base: '30px', md: '50px' }}
        pb="30px"
        mt="20px"
      >
        <Text
          color={textColor}
          textAlign={{
            base: 'center',
            xl: 'start',
          }}
          mb={{ base: '20px', xl: '0px' }}
          cursor="pointer"
          onClick={onOpen}
          _hover={{ opacity: 0.8 }}
        >
          {' '}
          &copy; {}
          <Text as="span" fontWeight="500" ms="4px">
            {currentYear} MyChoice Technologies. All Rights Reserved.
          </Text>
        </Text>
      </Flex>
      {theme && setTheme && (
        <Configurator
          theme={theme}
          setTheme={setTheme}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </>
  );
}
